export default __webpack_public_path__ + "static/media/library.361c1bbb.svg";